import {
  type GraphQLTrace,
  type GraphQLTraceKind,
} from "@digits-shared/components/Contexts/GraphQLTracerContext"

export const GRAPHQL_TRACE_LIMIT = 500

interface TraceSnapshot {
  traces: GraphQLTrace[]
  hasDroppedTraces: boolean
}

export type GraphQLTraceStore = ReturnType<typeof createGraphQLTraceStore>

export function createGraphQLTraceStore(canRecord: () => boolean) {
  let snapshot: TraceSnapshot = { traces: [], hasDroppedTraces: false }
  let active = true
  const listeners = new Set<() => void>()
  const publish = (next: TraceSnapshot) => {
    snapshot = next
    listeners.forEach((listener) => listener())
  }

  return {
    getSnapshot: () => snapshot,
    subscribe: (listener: () => void) => {
      listeners.add(listener)
      return () => {
        listeners.delete(listener)
      }
    },
    activate: () => {
      active = true
    },
    invalidate: () => {
      active = false
      publish({ traces: [], hasDroppedTraces: false })
    },
    addTrace: (trace: GraphQLTrace) => {
      if (!active || !canRecord()) return
      publish({
        traces: [trace, ...snapshot.traces].slice(0, GRAPHQL_TRACE_LIMIT),
        hasDroppedTraces:
          snapshot.hasDroppedTraces || snapshot.traces.length === GRAPHQL_TRACE_LIMIT,
      })
    },
    clearTrace: (id: string) => {
      publish({ ...snapshot, traces: snapshot.traces.filter((trace) => trace.id !== id) })
    },
    clearTracesByKind: (kind: GraphQLTraceKind) => {
      publish({ ...snapshot, traces: snapshot.traces.filter((trace) => trace.kind !== kind) })
    },
  }
}
